import { render } from "./create.vue?vue&type=template&id=a12fb5e2&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=a12fb5e2&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/projects/sms_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12fb5e2"]])

export default __exports__